interface KeyValue {
  key: string
  value: string
}

export const mapKeyValueArrayToObject = (arr: KeyValue[]): Record<string, string> => {
  return arr.reduce((acc, { key, value }) => {
    if (key && value) {
      // Check if both key and value are non-empty strings
      acc[key] = value
    }
    return acc
  }, {} as Record<string, string>)
}
